export default __webpack_public_path__ + "5bbf5c7.png";